import React from 'react';
import AutoSaveRadio from "./AutoSaveRadio";

const AutoSaveYesNoRadio = (props) => <AutoSaveRadio {...props} options={[
  {text: 'Yes', value: true},
  {text: 'No', value: false}
]}/>;

export default AutoSaveYesNoRadio;


// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveYesNoRadio.jsx